import { render, staticRenderFns } from "./jala-farm-select-ajax.vue?vue&type=template&id=13c3d20c&scoped=true&"
import script from "./jala-farm-select-ajax.vue?vue&type=script&lang=js&"
export * from "./jala-farm-select-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3d20c",
  null
  
)

export default component.exports